import React from "react";
import {
    Box,
    Typography,
    Stack,
    Paper,
    IconButton,
    CircularProgress,
} from "@mui/material";
import AttachmentIcon from "@mui/icons-material/AttachFile";
import DownloadIcon from "@mui/icons-material/Download";
import { useGetAttachmentsByCommentQuery } from "store/slices/apis/actionTrackerSlice";
import { API_END_POINT } from "config";
import { API_FILE_DOWNLOAD_POINT } from "config";

const CommentAttachments = ({ comment }) => {
    const { data, isLoading, isError } = useGetAttachmentsByCommentQuery(comment.projectActionCommentId, {
        skip: !comment?.projectActionCommentId, 
    });

    if (isLoading)
        return (
            <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
                <CircularProgress size={20} sx={{ mr: 1 }} />{" "}
                <Typography variant="caption">Loading attachments...</Typography>
            </Box>
        );

    if (isError || !data?.data?.length) return null;

    return (
        <Box sx={{ mt: 1.5 }}>
            <Typography
                variant="caption"
                sx={{ color: "text.secondary", mb: 0.5, display: "block" }}
            >
                Attachments:
            </Typography>
            <Stack spacing={1}>
                {data?.data?.map((file, i) => (
                    <Paper
                        key={i}
                        variant="outlined"
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            p: 1,
                            pl: 1.5,
                            borderRadius: 1,
                            borderColor: "#ddd",
                            bgcolor: "#fff",
                        }}
                    >
                        <Stack direction="row" spacing={1} alignItems="center" onClick={() => {
                            window.open(`${API_FILE_DOWNLOAD_POINT}${file?.filePath}`, '_blank');
                        }}>
                            <AttachmentIcon fontSize="small" color="action" />
                            <Typography
                                variant="body2"
                                sx={{
                                    color: "#1976d2",
                                    textDecoration: "none",
                                    cursor: "pointer",
                                }}
                            >
                                {file?.fileName}
                            </Typography>
                        </Stack>
                        <IconButton size="small">
                            <DownloadIcon fontSize="small" />
                        </IconButton>
                    </Paper>
                ))}
            </Stack>
        </Box>
    );
};

export default CommentAttachments;
